"use client";
import React, { useState, useEffect } from 'react';
import Detail from '../../Components/Detail/Detail'
import '../../css/Pages/PageDetail/PageDetails.css';
import logo from '../../images/logo_principal.png';
import { Link as Anchor, useNavigate, useLocation } from "react-router-dom";
import Footer from '../Footer/Footer';
import { sistemaURL } from '../../Components/url.js';
import { useMediaQuery } from '@react-hook/media-query';
import BtnWhatsapp from '../../Components/BtnWhatsapp/BtnWhatsapp.jsx';
import Cart from '../../Components/Cart/Cart.jsx';
export default function PageDetail() {
    const isScreenLarge = useMediaQuery('(min-width: 900px)');
    const [infoEmpresa, setInfoEmpresa] = useState({});
    useEffect(() => {
        cargarDatosEmpresa();
    }, []);
    const cargarDatosEmpresa = () => {
        fetch(`${sistemaURL}web/getEmpresaInfo`, {
            method: 'GET',
        }).then(response => response.json())
            .then(data => {
                setInfoEmpresa(data[0])
            })
            .catch(error => {
                console.error('Error al cargar productos:', error)
            });
    };
    return (
        <div className='pageDetail'>
            <nav>
                <Anchor to={`/`} className='logo new'>
                    <img src={logo} alt="logo" />
                    {/* <img src="/static/media/logo_principal.png" alt="Logo Principal" /> */}
                    {/* <div className='deColumnNav'>
                        <h2>    {informacion?.nombre}   </h2>
                        <strong>{informacion?.direccion}</strong>
                    </div> */}
                </Anchor>
            </nav>
            <Detail />
            {isScreenLarge &&
                <>
                    <Cart />
                    <BtnWhatsapp />
                </>
            }
            <Footer info={infoEmpresa} />

        </div>
    )
}
